import script from "./ArticleButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleButtons.vue?vue&type=script&setup=true&lang=js"

import "./ArticleButtons.vue?vue&type=style&index=0&id=d160776e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d160776e"]])

export default __exports__